module.exports = "/_next/static/images/an-356f0d975ec5b653d1365eb9768f4c0e.svg";